import { defineComponent as _defineComponent } from 'vue';
import { reactive, ref, watch, getCurrentInstance, onBeforeMount, computed } from 'vue';
import SpecialDate from '@blade-sxp/account/pages/attendanceManagement/components/specialDate.vue';
import { useAttendanceMagStore } from '@blade-sxp/account/store/attendanceMag';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const store = useAttendanceMagStore();
        const attendanceMagRef = ref();
        const personList = computed(() => store.portraitLibList);
        const deviceOptions = computed(() => store.deviceTree);
        const vm = getCurrentInstance()?.proxy;
        // const disableSave = ref(true);
        const form = reactive({
            id: '',
            device: [],
            person: [],
            hour: ['09:00:00', '18:00:00'],
            day: [],
            mustDate: [],
            noCheckDate: [],
        });
        const deviceProps = reactive({
            value: 'id',
            label: 'name',
            children: 'children',
            leaf: 'nodeType',
            multiple: true,
            emitPath: false,
            // disabled: 'status',
        });
        const rules = reactive({
            device: [{ required: true, message: `${vm?.$t('selectTips')}`, trigger: 'change' }],
            person: [{ required: true, message: `${vm?.$t('selectTips')}`, trigger: 'change' }],
            hour: [{ required: true, message: `${vm?.$t('selectTips')}`, trigger: 'change' }],
            day: [{ required: true, message: `${vm?.$t('selectTips')}`, trigger: 'change' }],
        });
        const daysConfig = ref([
            {
                key: '1',
                value: '1',
                label: vm?.$t('Monday'),
            },
            {
                key: '2',
                value: '2',
                label: vm?.$t('Tuesday'),
            },
            {
                key: '3',
                value: '3',
                label: vm?.$t('Wednesday'),
            },
            {
                key: '4',
                value: '4',
                label: vm?.$t('Thursday'),
            },
            {
                key: '5',
                value: '5',
                label: vm?.$t('Friday'),
            },
            {
                key: '6',
                value: '6',
                label: vm?.$t('Saturday'),
            },
            {
                key: '7',
                value: '7',
                label: vm?.$t('Sunday'),
            },
        ]);
        const dayConfig = reactive({
            mondayPeriod: '1',
            tuesdayPeriod: '2',
            wednesdayPeriod: '3',
            thursdayPeriod: '4',
            fridayPeriod: '5',
            saturdayPeriod: '6',
            sundayPeriod: '7',
        });
        watch(() => store.attendanceRule, (nv) => {
            const target = nv?.[0] ?? {};
            const { deviceIds = [], attendancePortrait = [], startTime = '09:00:00', endTime = '18:00:00', specialDaysExclude = [], specialDaysInclude = [], id = '', } = target;
            console.log('attendanceRule', nv);
            form.device = deviceIds.map((i) => String(i));
            form.person = attendancePortrait.map((i) => String(i.portraitLibId));
            form.hour = [startTime, endTime];
            form.day = getDays(target);
            form.mustDate = specialDaysInclude || [];
            form.noCheckDate = specialDaysExclude || [];
            form.id = id;
        }, { deep: true });
        function getDays(data) {
            const days = [];
            for (let k in data) {
                const val = data[k];
                if (!val)
                    continue;
                dayConfig?.[k] && days.push(dayConfig[k]);
            }
            return days;
        }
        function getDaysParam(days) {
            let obj = {};
            for (let k in dayConfig) {
                const val = dayConfig[k];
                obj[k] = !!days.find((d) => d === val);
            }
            return obj;
        }
        function changeSpecialDate({ mustDate = [], noCheckDate = [] }) {
            form.mustDate = mustDate;
            form.noCheckDate = noCheckDate;
            console.log('changeSpecialDate form', form);
        }
        function getAddRuleParam() {
            const portraits = form.person.map((p) => {
                return {
                    allInclude: true,
                    partitionInclude: [],
                    portraitLibId: p,
                };
            });
            return {
                ...getDaysParam(form.day),
                attendancePortrait: portraits,
                deviceIds: [...form.device],
                startTime: form.hour?.[0],
                endTime: form.hour?.[1],
                specialDaysExclude: [...form.noCheckDate],
                specialDaysInclude: [...form.mustDate],
            };
        }
        async function handleAdd() {
            try {
                const param = getAddRuleParam();
                await store.addRule(param);
                vm?.$message.success('Success');
            }
            catch (e) {
                // vm?.$message.error('Error');
                console.log(e);
            }
        }
        async function handleUpdate() {
            console.log('handleUpdate');
            try {
                const param = { ...getAddRuleParam(), id: form.id };
                await store.updateRule(param);
                vm?.$message.success('Success');
            }
            catch (e) {
                // vm?.$message.error('Error');
                console.log(e);
            }
        }
        function handleSave() {
            attendanceMagRef.value?.validate((valid) => {
                if (valid) {
                    if (!form.id) {
                        handleAdd();
                    }
                    else {
                        handleUpdate();
                    }
                }
                else {
                    return false;
                }
            });
        }
        function initData() {
            store.getPortraitlibList();
            store.getDeviceTree();
            store.getRule();
        }
        onBeforeMount(() => {
            initData();
        });
        return { __sfc: true, store, attendanceMagRef, personList, deviceOptions, vm, form, deviceProps, rules, daysConfig, dayConfig, getDays, getDaysParam, changeSpecialDate, getAddRuleParam, handleAdd, handleUpdate, handleSave, initData, SpecialDate };
    }
});
